// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__r7-Fi","header":"MergedInvoice_header__3qivo"};